// React
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import uiConnect from 'shared/redux/interface'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import { triggerUserFrameworkBookEvent } from 'shared/utils/userFrameworkEvents'
import cartActions from 'store/v2/redux/actions/cart'
import Format from 'shared/utils/format'

class Line extends React.Component {
  static displayName = 'Line'

  static propTypes = {
    updateUI: PropTypes.func,
    line: PropTypes.any,
    useAvailability: PropTypes.bool,
    hasDates: PropTypes.any,
    decreaseQty: PropTypes.func,
    increaseQty: PropTypes.func,
    currency: PropTypes.any,
    showPrices: PropTypes.any,
    hideProductAvailabilityQuantities: PropTypes.bool,
    remove: PropTypes.func,
    ui: PropTypes.shape({
      quantity: PropTypes.number,
      deleting: PropTypes.bool
    }),
    style: PropTypes.shape({
      opacity: PropTypes.number,
      transform: PropTypes.string
    }),
    t: PropTypes.func
  }

  componentDidMount = () => {
    const { line, updateUI } = this.props

    updateUI({ quantity: line.quantity })
  }

  componentDidUpdate = (prevProps) => {
    const { line, updateUI } = this.props

    if (line && prevProps.line && line.quantity !== prevProps.line.quantity) {
      updateUI({ quantity: line.quantity })
    }
  }

  render () {
    const {
      style,
      line,
      currency,
      hasDates,
      useAvailability,
      hideProductAvailabilityQuantities,
      showPrices,
      decreaseQty,
      remove,
      increaseQty,
      ui,
      t
    } = this.props

    const available = line.available_quantity >= ui.quantity
    const statusClass = available ? 'bq-available' : 'bq-unavailable'
    const titleClass = useAvailability ? 'bq-small' : 'bq-large'

    if (line.product_type === 'service') return null

    return (
      <div
        key={line.title}
        style={style}
        className="bq-list-item"
      >
        {line?.photo_url && <img className="bq-product-image" src={line.photo_url} />}
        {!line?.photo_url && (
          <span className="bq-no-photo">
            <i className="bq-no-photo bq-icon-image fas fa-image" />
          </span>
        )}
        <div className="bq-cart-line">
          <div className={`bq-product-name ${titleClass}`}>{line.title}</div>
          {hasDates && useAvailability && (
            <span className={`bq-status-indicator ${statusClass}`}>
              {!hideProductAvailabilityQuantities && (
                <Fragment>
                  <span className="bq-status-quantity">
                    {line.available_quantity}
                    {' '}
                  </span>
                  {t('user.store.available')}
                </Fragment>
              )}
              {hideProductAvailabilityQuantities &&
                t(available ? 'user.store.available' : 'user.store.unavailable')}
            </span>
          )}
          <div className={`bq-quantity ${ui.deleting ? 'disabled' : 'enabled'}`}>
            <button className="bq-quantity-toggle" onClick={decreaseQty}>
              -
            </button>
            <span className="bq-quantity">{ui.quantity}</span>
            <button className="bq-quantity-toggle" onClick={increaseQty}>
              +
            </button>
          </div>
        </div>
        <div className="bq-line-footer">
          {showPrices && !line.discountable && (
            <p className="bq-product-discountable-hint">
              <i className="bq-icon-tag fas fa-tag" />
              {t('user.store.not_discountable_hint')}
            </p>
          )}
          {showPrices && line.display_price_in_cents > 0 && (
            <p className="bq-price">{Format.money(line.display_price_in_cents, currency)}</p>
          )}
        </div>
        <button className="bq-remove-product" onClick={ui.deleting ? undefined : remove}>
          <i className="bq-icon-cross fas fa-times" />
        </button>
      </div>
    )
  }
}

const uiToProps = {
  persist: true,
  state: {
    quantity: 0,
    deleting: false
  }
}

const mapStateToProps = (state, props) => {
  return {
    currency: state.client.currency.toJS(),
    useAvailability: state.settings.get('store.use_availability') && props.line.tracking_type !== 'none',
    hideProductAvailabilityQuantities: state.settings.get('store.hide_product_availability_quantities'),
    showPrices: state.settings.get('store.use_prices')
  }
}

const mapDispatchToProps = (_dispatch, props) => {
  const book = function (quantity) {
    if (quantity === 0) {
      props.updateUI({ deleting: true })
    }

    if (quantity === -1) {
      return
    }

    props.updateUI({ quantity })

    return cartActions
      .book({
        item_id: props.line.item_id,
        line_id: props.line.id,
        quantity,
        type: 'set',
        apiVersion: 1
      })
      .then(() => {
        const quantityChange = quantity - props.line.quantity

        triggerUserFrameworkBookEvent(props.line.item_id, quantityChange)
      })
  }

  return {
    increaseQty: () => {
      const newQuantity = props.ui.quantity + 1

      return book(newQuantity)
    },
    decreaseQty: () => {
      const newQuantity = props.ui.quantity - 1

      return book(newQuantity)
    },
    remove: () => book(0)
  }
}

export default compose(
  withTranslation('user'),
  uiConnect('Line', uiToProps),
  reduxConnect(mapStateToProps, mapDispatchToProps)
)(Line)
